import React from 'react';
import clsx from 'classnames';

export function Text({
  className,
  children,
  color,
  italic,
  bold,
  variant = 'body-regular',
  ...props
}) {
  const textClass = clsx(
    {
      'cdl-text': true,
      'cdl-text--italic': italic,
      'cdl-text--bold': bold,

      'cdl-text--body-large': variant === 'body-large',
      'cdl-text--body-regular': variant === 'body-regular',
      'cdl-text--body-small': variant === 'body-small',
      'cdl-text--caption': variant === 'caption',
      'cdl-text--caption-small': variant === 'caption-small',
      'cdl-text--quote': variant === 'quote',
      'cdl-text--overline': variant === 'overline',
      'cdl-text--table': variant === 'table',

      'cdl-text--foreground-primary': color === 'foreground-primary',
      'cdl-text--foreground-secondary': color === 'foreground-secondary',
      'cdl-text--foreground-tertiary': color === 'foreground-tertiary',
      'cdl-text--brand-primary-base': color === 'brand-primary-base',
      'cdl-text--brand-secondary-base': color === 'brand-secondary-base',
      'cdl-text--brand-tertiary-base': color === 'brand-tertiary-base',
      'cdl-text--brand-accent-base': color === 'brand-accent-base',
    },
    className
  );

  return (
    <p className={textClass} {...props}>
      {children}
    </p>
  );
}
